import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import CallsTable from "./components/CallsTable";
import TimelineChart from "./components/TimelineChart";
import DashboardHeader from "./components/DashboardHeader";
import Signup from "./components/Signup";
import Login from "./components/Login";
import CallsPage from "./components/Tempcallpage";
import TempCallsTable from "./components/TemplateCalls";
import AdminPage from "./components/Adminpage";
import ForgotPassword from "./components/ForgotPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import ResetPassword from "./components/ResetPassword";
import {BASE_URL} from "./config";
import CallDashboard from "./components/CallDashboard";
import OperationsExpensePage from "./components/operations/OperationsExpensePage";
import AdminPanel from "./components/AdminDashboard";
import MarketingCost from "./components/marketing/MarketingExpense";
import MarketingExpenseTable from "./components/marketing/MarketingExpenseTable";
import ReportsPage from "./components/marketing/MarketingDashboard";
import AgentPerformanceDashboard from "./components/AgentPerformanceDashboard";
import ChargebackTracker from "./components/chargeback/ChargebackTracker";
import AnalyticsDashboard from "./components/AnalyticsDashboard"; 
import AgentReport from "./components/report/AgentReport";
import QueueReport from "./components/report/QueueReport";
import GatewayReport from "./components/report/GatewayReport";
import ChargebackReport from "./components/report/ChargebackReport";
import MonthlyMcoReport from "./components/report/MonthyReport";
import AgentTimelineDashboard from "./components/AgentTimeline";
import AgentStatusDrawer from "./components/AgentStatusDrawer";
import AgentOperationsDashboard from "./components/AgentOperationsDashboard";
import DesktopApp from "./components/DesktopView";
import Layout from "./components/Layout"

function App() {
  const [data, setData] = useState({ stats: {}, calls: [] });
  const [dateRange, setDateRange] = useState({
    startDate: "2025-08-01",
    endDate: "2025-08-29",
  });
   const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(`${BASE_URL}session.php`, {
          credentials: "include",
        });
        const data = await res.json();
        if (data.status === "success") {
          setUser(data.user);
        } else {
          setUser(null);
        }
      } catch {
        setUser(null);
      } finally {
        setLoadingUser(false);
      }
    };

    fetchUser();
  }, []);

  const handleToggleSidebar = () => {};
  const handleDateRangeChange = (range) => setDateRange(range);

  if (loadingUser) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-300 text-lg">
        Checking session...
      </div>
    );
  }

  return (
    <Router>
      <Layout>
      <Routes>
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/operationscost" 
        element={
        <ProtectedRoute
              allowedRole="admin"
              element={
              <div>
                <DashboardHeader/>
                <OperationsExpensePage />
              </div>} 
              />}/>
        <Route path="/marketingcost" 
        element={
        <ProtectedRoute
              allowedRole="admin"
              element={
              <div>
                <DashboardHeader/>
                <MarketingCost />
              </div>} 
              />}/>
        <Route path="/reports/monthly-mco" element={
          <ProtectedRoute
              allowedRole="admin"
              element={
              <div>
                <DashboardHeader/>
                <MonthlyMcoReport />
                </div>}
            />
        } />
        <Route path="/live-agent-report" element={
          <ProtectedRoute
              allowedRole="admin"
              element={
              <div>
                <DashboardHeader/>
               <AgentTimelineDashboard />
                </div>}
            />
        } />
        <Route
          path="/admin" 
          element={
            <ProtectedRoute
              allowedRole="admin"
              element={
              <div>
                <DashboardHeader/>
                <AdminPanel/> 
                </div>}
            />
          }
        />
        <Route
          path="/analytics-dashboard" 
          element={
            <ProtectedRoute
              allowedRole="admin"
              element={
              <div>
                <DashboardHeader/>
                <AnalyticsDashboard />
                </div>}
            />
          }
        />
        <Route
          path="/users" 
          element={
            <ProtectedRoute
              allowedRole="admin"
              element={
               <div>
                <DashboardHeader/>
                <AdminPage />
                </div>}
            />
          }
        />
        <Route
          path="/agent-report" 
          element={
            <ProtectedRoute
              allowedRole="admin"
              element={
              <div>
                <DashboardHeader/>
                <AgentReport />
                </div>}
            />
          }
        />
        <Route
          path="/queue-report" 
          element={
            <ProtectedRoute
              allowedRole="admin"
              element={
              <div>
                <DashboardHeader/>
                <QueueReport />
                </div>}
            />
          }
        />
        <Route
          path="/gateway-report" 
          element={
            <ProtectedRoute
              allowedRole="admin"
              element={
              <div>
                <DashboardHeader/>
                <GatewayReport />
                </div>}
            />
          }
        />
        <Route
          path="/chargeback-report" 
          element={
            <ProtectedRoute
              allowedRole="admin"
              element={
              <div>
                <DashboardHeader/>
                <ChargebackReport />
                </div>}
            />
          }
        />
        <Route
          path="/agentdash" 
          element={
            <ProtectedRoute
              allowedRole="user"
              element={
               <div>
                <DashboardHeader/>  
                <AgentPerformanceDashboard />
                </div>}
            />
          }
        />
        <Route
  path="/call-logs"
  element={
    <div className="flex flex-col min-h-screen bg-primary text-gray-100 relative">
      <DashboardHeader />

      <main className="flex-1 p-6">
        <div>
          <AgentPerformanceDashboard />
        </div>

        <TempCallsTable />
      </main>

      {/* ✅ Add drawer HERE */}
      {/* <AgentStatusDrawer /> */}
    </div>
  }
/>

        <Route
          path="/"
          element={
            user ? <Navigate to="/analytics-dashboard" replace /> : <Navigate to="/login" replace />
          }
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/chargeback" element={
          <div><DashboardHeader /><ChargebackTracker /></div>} />
        <Route path="/analytics" element={<CallDashboard />}/>
        <Route path="/marketing-expense-table" element={<ReportsPage />}/>
        <Route path="/reports" element={<ReportsPage />}/>
        <Route path="/desktop-view" element={<DesktopApp />}/>
        <Route path="/agent-operations-dashboard" element={

              <div>
                <DashboardHeader/>
                <AgentOperationsDashboard />
                </div>
           
          } />
        
      </Routes>
      </Layout>
    </Router>
  );
}

export default App;
